import Http from 'services/Http';

const ContentTracking = {
  trackLinkClick({ messageId, url }) {
    return Http.post('/v1/link-clicks', { messageId, url }).catch(() => {});
  },

  trackArticleView({ messageId, articleId, timeSpentMs }) {
    return Http.post('/v1/article-views', { messageId, articleId, timeSpentMs }).catch(() => {});
  },

  trackVideoWatch({ messageId, attachmentId, durationWatchedMs, totalDurationMs }) {
    return Http.post('/v1/video-watches', {
      messageId,
      attachmentId,
      durationWatchedMs,
      totalDurationMs,
    }).catch(() => {});
  },
};

export default ContentTracking;
